import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import Link from 'next/link';

import GLOBAL_MEDIA_QUERIES from 'constants/Screen';
import trackAction from 'utils/tracking';

import IconSvg from 'components/Core/IconSvg';

import { BreadcrumbsLink } from './Breadcrumbs.styles';

const Breadcrumbs = ({ breadcrumbs, light }) => {
  const onClickBreadCrumb = (label) => trackAction('breadcrumbs', label, 'click');
  const renderBreadCrumbLink = (url, title, label) => {
    if (url === '/') {
      return (
        <Link href="/" passHref>
          <BreadcrumbsLink light onClick={() => onClickBreadCrumb(title)}>
            {label}
          </BreadcrumbsLink>
        </Link>
      );
    }
    return (
      <Link href="/[...slug]" as={url} passHref>
        <BreadcrumbsLink light onClick={() => onClickBreadCrumb(title)}>
          {label}
        </BreadcrumbsLink>
      </Link>
    );
  };

  return (
    <div className={`flex items-center my-2 md:mb-5 md:mt-4 text-sm ${light ? 'text-basic-400' : 'text-basic-700'}`}>
      <Media queries={GLOBAL_MEDIA_QUERIES} defaultMatches={{ lg: true }}>
        {(matches) => {
          if (matches.xs || matches.sm) {
            const { length } = breadcrumbs;
            if (length > 1) {
              const backItem = breadcrumbs[length - 2];
              return (
                <div key={backItem.url} className="flex items-center">
                  <IconSvg icon="arrow-left" size={11} className="ml-0 mr-2 md:mx-2 text-primary" />
                  {renderBreadCrumbLink(backItem.url, backItem.title, 'Terug')}
                </div>
              );
            }
            const backItem = breadcrumbs[0];
            return (
              <div key={backItem.url} className="flex items-center">
                <span className="font-bold text-basic-600 transition-color ease-out duration-150">
                  {backItem.title}
                </span>
              </div>
            );
          }
          return (
            <>
              {breadcrumbs.map((item, index, { length }) => (
                <div key={item.url} className="flex items-center">
                  {index !== 0 && <IconSvg icon="arrow-right" size={7} className="ml-0 mr-2 md:mx-2 text-primary" />}
                  {index === length - 1 ? (
                    <span
                      className={`font-bold transition-color ease-out duration-150 ${
                        light ? 'text-basic-100' : 'text-basic-600'
                      }`}
                    >
                      {item.title}
                    </span>
                  ) : (
                    renderBreadCrumbLink(item.url, item.title, item.title)
                  )}
                </div>
              ))}
            </>
          );
        }}
      </Media>
    </div>
  );
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  ).isRequired,
  light: PropTypes.bool,
};

Breadcrumbs.defaultProps = {
  light: false,
};

export default Breadcrumbs;
